import {Category} from '~app/modules/generic/models/index';

export interface BrandInfoState {
  id: string;
  name: string;
  slug: string;
  productsCount: number;
  categoriesCount: number;
  categories: Category[];
}

export const BrandInfoInitialState: BrandInfoState = {
  id: '',
  name: '',
  slug: '',
  productsCount: 0,
  categoriesCount: 0,
  categories: []
};
